import React from 'react';
import { Button } from 'primereact/button';
import { BreadCrumb } from 'primereact/breadcrumb';
import { useLocation } from 'react-router-dom';
import { useLocalState } from './util/useLocalStorage';



const AppBreadcrumb = (props) => {
    const [username, setUsername] = useLocalState("", "username");
    const location = useLocation();
    const pathname = location.pathname === '/' ? ['', ''] : location.pathname.split('/').slice(1);

    const activeRoute = props.routes.filter((route) => {
        return route.parent.replace(/\s/g, '').toLowerCase() === pathname[0] && route.label.replace(/\s/g, '').toLowerCase() === pathname[1];
    });

    let model;

    if (!activeRoute.length) {
        model = [{ label: '' }];
    } else {
        model = activeRoute[0].parent === '' && activeRoute[0].label === '' ? [{ label: 'Dashboard' }] : [{ label: activeRoute[0].parent }, { label: activeRoute[0].label }];
    }

    const home = { icon: 'pi pi-home', url: '/' };

    return (
        <div className="layout-breadcrumb-container flex justify-content-between align-items-center shadow-1">
            <BreadCrumb model={model} home={home} className="layout-breadcrumb p-pl-4 p-py-2" />

            <div className="layout-breadcrumb-buttons flex align-items-center pr-3">
                <Button type="button" className="p-button p-button-rounded p-button-text p-button-plain mr-3 bg-yellow-500 text-white font-bold text-sm w-full">{username}</Button>
                
            </div>

        </div>
    );
};

export default AppBreadcrumb;
